<template>
  <div>
    <div class="heading-travel-policy">
      <span :class="rule.isActive ? 'tag is-success' : 'tag'">
        Standard rule
      </span>
      <div class="right-content">
        <div class="lefttext">
          <p class="paragrapgh">Unused Tickets</p>
          <p>Trigger when a traveler chooses a flight with an airline for which there is no unused ticket stored on their profile.</p>
        </div>
        <div class="allbtns">
          <b-switch
            rounded
            left-label
            :value="rule.isActive"
            v-model="rule.isActive"
            @input="updateValue"
          >
            {{ rule.isActive ? "Active" : "Inactive" }}
          </b-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        type: "air",
        isActive: false,
        name: "useUnusedTicketIfExists",
        message: "Trigger when a traveler chooses a flight with an airline for which there is no unused ticket stored on their profile.",
      }),
    },
  },
  data() {
    return {
      rule: null,
    };
  },
  watch: {
    value: {
      handler() {
        const rule = JSON.stringify(this.rule);
        const value = JSON.stringify(this.value);

        if (rule !== value) {
          this.rule = this.value;
        }
      },
      deep: true,
    },
  },
  created() {
    this.rule = this.value;
    this.updateValue();
  },
  methods: {
    updateValue() {
      this.$emit("update", this.rule);
    },
  },
};
</script>
